import { useMutation, useQueryClient } from "@tanstack/react-query";
import { restoreJobTitle as apiRestore } from "../../api/apiJobTitles";
import { useSnackbar } from "notistack";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useRestoreJobTitle() {
    const queryClient = useQueryClient();
    const { enqueueSnackbar } = useSnackbar();

    const { mutate: restoreJobTitle, isPending: isRestore } = useMutation({
        mutationFn: (id) => apiRestore(id),
        onSuccess: (response) => {
            enqueueSnackbar(response.message, { variant: "success" });
            queryClient.invalidateQueries({ queryKey: ["jobTitles"] });
        },
        onError: (err) => {
            const msg = getErrorMessageFromAxiosError(err, "Something went wrong!");
            enqueueSnackbar(msg, { variant: "error" });
        },
    });

    return { restoreJobTitle, isRestore };
}
